import React from 'react';

// eslint-disable-next-line max-len
const MOI_LOGO = '/themes/theme/moi/moi-logo.png';

const minHeight200 = {
  'min-height': '200px',
};

const textAlignCentre = {
  'text-align': 'center',
};

const MOITheme = {
  headerLogo: {
    src: MOI_LOGO,
    alt: 'MOI Logo',
    size: 80,
  },
  darkLogo: {
    src: MOI_LOGO,
    alt: 'MOI Logo',
    size: 150,
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '4px solid rgb(111 111 111)',
    height: 90,
  },
  linkStyle: {
    color: '#000',
    fontWeight: 800,
    fontSize: '120%',
  },
  title: 'MOI-Digital',
  isLightOnDark: false,
  organisationId: 'efcb872a-50d9-417c-b6a5-ba427dba4c84',
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        height="120"
        src={MOI_LOGO} alt="MOI Logo"
      />
      <br /><br />
      {/* <h3>MOI-Digital</h3> */}
    </div>
  ),
  shareSite: 'https://moir.dyzio.co',
  primaryButtonColorStyle: {
    background: '#000',
    color: 'white',
    margin: 5,
  },
  tagButtonColor: 'teal',
  formTitle: () => (
    <h3 style={textAlignCentre}>--Form Title--</h3>
  ),
  welcomeHtml: () => (
    <div style={minHeight200}>
      <p style={textAlignCentre}>--Customisable tab title--</p>
      <br />
      <p style={textAlignCentre}>--This block is customisable--</p>
      <br />
    </div>
  ),
  signUpHtml: () => (
    <div style={minHeight200}>
      <p style={textAlignCentre}>--Customisable sign up info title--</p>
      <br />
      <p style={textAlignCentre}>--This block is customisable--</p>
      <br />
    </div>
  ),
  finishedHtml: () => (
    <div style={minHeight200}>
      <p style={textAlignCentre}>--This block is customisable--</p>
      <br />
    </div>
  ),
  socialHandle1HtmlTop: () => (
    <h3 style={textAlignCentre}>--This block is customisable--</h3>
  ),
  socialHandle1HtmlBottom: () => (
    <h3 style={textAlignCentre}>--This block is customisable--</h3>
  ),
  socialHandle2HtmlTop: () => (
    <h3 style={textAlignCentre}>--This block is customisable--</h3>
  ),
  socialHandle2HtmlBottom: () => (
    <h3 style={textAlignCentre}>--This block is customisable--</h3>
  ),
  socialHandle3HtmlTop: () => (
    <h3 style={textAlignCentre}>--This block is customisable--</h3>
  ),
  socialHandle3HtmlBottom: () => (
    <h3 style={textAlignCentre}>--This block is customisable--</h3>
  ),
  personalDetailHtmlTop: () => (
    <h3 style={textAlignCentre}>--This block is customisable--</h3>
  ),
  personalDetailHtmlBottom: () => (
    <h3 style={textAlignCentre}>--This block is customisable--</h3>
  ),
  tagsHtmlTop: () => (
    <h3 style={textAlignCentre}>--This block is customisable--</h3>
  ),
  tagsHtmlBottom: () => (
    <h3 style={textAlignCentre}>--This block is customisable--</h3>
  ),
};

export default MOITheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/moi.js
 **/